import axios from "axios";

const isPreview = window.location.hostname.includes("preview.emergentagent.com") || window.location.hostname === "localhost";
export const BACKEND_URL = isPreview ? process.env.REACT_APP_BACKEND_URL : "";
const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const url = original?.url || "";
    if (
      error.response?.status === 401 &&
      !original._retry &&
      !url.includes("/auth/")
    ) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function inr(n, withSymbol = true) {
  const num = Number(n || 0);
  const s = num.toLocaleString("en-IN", { maximumFractionDigits: 0 });
  return withSymbol ? `₹${s}` : s;
}

let _psCache = null;
let _psTime = 0;
let _psPromise = null;
export function getPublicSettings(maxAgeMs = 30000) {
  const now = Date.now();
  if (_psCache && now - _psTime < maxAgeMs) return Promise.resolve(_psCache);
  if (_psPromise) return _psPromise;
  _psPromise = api.get("/public-settings").then((r) => {
    _psCache = r.data; _psTime = Date.now(); _psPromise = null; return r.data;
  }).catch((e) => { _psPromise = null; throw e; });
  return _psPromise;
}

export default api;
